<!-- 操作信息table -->
<template>
    <el-table border :header-cell-style="{
        backgroundColor: '#FDEFE7', color: '#000000'
    }" :data="tableData" style="width: 100%">
        <el-table-column fixed="left" align="center" prop="date" label="操作者类型" width="120">
        </el-table-column>
        <el-table-column align="center" prop="name" label="供应商名称" width="200">
        </el-table-column>
        <el-table-column align="center" prop="address" label="操作者信息" width="120">
        </el-table-column>
        <el-table-column align="center" prop="name" label="操作时间" width="120">
        </el-table-column>
        <el-table-column align="center" prop="name" label="触发原因/按键" width="120">
        </el-table-column>
        <el-table-column align="center" prop="name" label="操作后订单状态" width="180">
        </el-table-column>
        <el-table-column align="center" prop="name" label="备注">
        </el-table-column>
    </el-table>
</template>
<script>
export default {
    props: {
        tableData: {
            type: Array,
            default: () => []
        }
    },
    components: {},
    data() {
        return {

        }
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped></style>